export default () => {
    const buildQueryObjects = () => {
        const queryString = window.location.search.slice(1);
        const query = {};
        let queryArray = [];

        if (queryString) {
            queryArray = queryString.split('&').map(item => {
                const pair = item.split('=');
                const name = decodeURIComponent(pair.shift());
                const value = decodeURIComponent(pair.join('='));

                // set query object properties
                query[name] = query[name] || [];
                query[name].push(value);

                // return array item
                return { name, value };
            });
        }

        return { object: query, array: queryArray };
    };

    const query = buildQueryObjects();
    window.buildQueryObjects = buildQueryObjects;
    window.queryArray = query.array;
    window.query = query.object;
};
